import {mapGetters} from 'vuex'


export default {
  name: 'title-box',
  components: {},
  props: [],
  data () {
    return {
      portfolio_name: ''
    }
  },
  computed: {
    ...mapGetters(['get_PD_userData']),
  },
  mounted () {
    this.portfolio_name = this.get_PD_userData['portfolio_name']
  },
  methods: {

  }
}


